// src/extenders/wishlist-products.js
var WishlistProducts = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    const rawDataElement = this.querySelector("[data-wishlist-products-json]");
    const productTemplate = (_a = this.closest("section")) == null ? void 0 : _a.querySelector("[data-wishlist-product-template]");
    if (!rawDataElement || !productTemplate)
      return;
    const rawData = JSON.parse(rawDataElement.textContent);
    const normalizeWishlistProductId = (productId) => {
      if (productId === null || productId === void 0)
        return "";
      let normalizedId = String(productId).trim();
      if (normalizedId.startsWith('"') && normalizedId.endsWith('"') || normalizedId.startsWith("'") && normalizedId.endsWith("'")) {
        normalizedId = normalizedId.slice(1, -1).trim();
      }
      return normalizedId;
    };
    const productsJSON = rawData.wishlist_products.map(normalizeWishlistProductId).filter((product) => product && product !== "Default value");
    const routes = rawData.routes || {};
    const translations = rawData.translations || {};
    const rootUrl = routes.root_url || "/";
    const loginUrl = routes.account_login_url || "/account/login";
    const normalizedRootUrl = rootUrl.endsWith("/") ? rootUrl : `${rootUrl}/`;
    const baseUrl = new URL(normalizedRootUrl, window.location.origin);
    const buildProductUrl = (handle) => new URL(`products/${handle}`, baseUrl).toString();
    const handleProductButtonTemplate = (product) => {
      var _a2;
      const productNode = product.data.product;
      const productId = productNode.id.replace("gid://shopify/Product/", "");
      const productUrl = buildProductUrl(productNode.handle);
      const templateContent = productTemplate.content.cloneNode(true);
      const productButton = templateContent.querySelector("[data-wishlist-product-button]");
      const wishlistHandler = templateContent.querySelector("[data-wishlist-product-wishlist-handler]");
      const loginMessage = templateContent.querySelector("[data-wishlist-login-message]");
      const loginLink = templateContent.querySelector("[data-wishlist-login-link]");
      const imageLink = templateContent.querySelector("[data-wishlist-product-image-link]");
      const imageWrapper = templateContent.querySelector("[data-wishlist-product-image-wrapper]");
      const titleLink = templateContent.querySelector("[data-wishlist-product-title-link]");
      const title = templateContent.querySelector("[data-wishlist-product-title]");
      const price = templateContent.querySelector("[data-wishlist-product-price]");
      const ctaLink = templateContent.querySelector("[data-wishlist-product-cta-link]");
      const cta = templateContent.querySelector("[data-wishlist-product-cta]");
      productButton.id = productId;
      wishlistHandler.id = productId;
      wishlistHandler.dataset.customer = rawData.customer || "";
      loginMessage.textContent = translations.please_login_to_add_to_wishlist || "";
      loginLink.href = loginUrl;
      loginLink.textContent = translations.login || "Login";
      imageLink.href = productUrl;
      if ((_a2 = productNode.featuredImage) == null ? void 0 : _a2.url) {
        const image = document.createElement("img");
        image.src = productNode.featuredImage.url;
        image.alt = productNode.title;
        image.className = "w-full object-cover object-top aspect-[242/266] transition-opacity";
        imageWrapper.appendChild(image);
      }
      titleLink.href = productUrl;
      title.textContent = productNode.title;
      const priceNode = productNode.variants.edges[0].node.price;
      price.textContent = new Intl.NumberFormat("nl-NL", { style: "currency", currency: priceNode.currencyCode }).format(priceNode.amount).replace(/\s/g, "");
      ctaLink.href = productUrl;
      cta.textContent = translations.view_product || "Bekijk product";
      this.appendChild(templateContent);
    };
    if (productsJSON.length > 0) {
      productsJSON.forEach((product) => {
        const productId = parseInt(product, 10);
        if (Number.isNaN(productId)) {
          console.error("\u274C Invalid wishlist product ID:", product);
          return;
        }
        const productQuery = `
        {
          product(id: "gid://shopify/Product/${productId}") {
            id
            title
            handle
            featuredImage {
              url
            }
            variants(first: 1) {
              edges {
                node {
                  id
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `;
        fetch("https://ananda-bv.myshopify.com/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ query: productQuery })
        }).then((r) => r.json()).then((result) => {
          if (result && result.data && result.data.product) {
            handleProductButtonTemplate(result);
          } else {
            console.error("\u274C Product not found for ID:", product);
            console.error("Response:", result);
            if (result && result.errors) {
              console.error("GraphQL errors:", result.errors);
            }
          }
        }).catch((error) => {
          console.error("\u274C Network/Request error for product", product, ":", error);
        });
      });
    }
  }
};
if (!customElements.get("wishlist-products")) {
  customElements.define("wishlist-products", WishlistProducts);
}
